// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicosCategorias_UpdateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/servicos_categorias/update
 *
 * Updates an existing service category.
 */
import { registerContract } from './validate'

export interface ServicosCategorias_UpdateInput {
servicoscategoria_id: number
servicoscategoria_nome?: string
servicoscategoria_prazo_retorno_dias?: number
servicoscategoria_prazo_garantia_dias?: number
servicoscategoria_produtos_associados?: number
}

registerContract('ServicosCategorias_UpdateInput', {
  servicoscategoria_id:                  { type: 'number',  required: true },
  servicoscategoria_nome:                { type: 'string',  required: false },
  servicoscategoria_prazo_retorno_dias:  { type: 'number',  required: false },
  servicoscategoria_prazo_garantia_dias: { type: 'number',  required: false },
  servicoscategoria_produtos_associados: { type: 'number',  required: false },
})
